import React from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/subject/subjects/createSubjectContainer';
import { actions } from '../../../redux/subject/subjects';

export default function () {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
